import React, { useState, useEffect } from 'react'
import {
  Box,
  Fab,
  Grid,
  Dialog,
  IconButton,
  Typography,
  LinearProgress,
  makeStyles
} from '@material-ui/core'
import { green, red, blue } from '@material-ui/core/colors'
import { Add, Edit, Delete, Check, Close, HourglassEmpty } from '@material-ui/icons'
import { useStoreState, useStoreActions } from 'easy-peasy'
import { toast } from 'react-toastify'
import { DataGrid } from 'devextreme-react'
import { Column } from 'devextreme-react/data-grid'
import { getIdentity } from '../../Utils/auth'
import http from '../../Utils/http'
import Layout from '../../components/Layout/layout'
import ShapefileCreate from '../../components/Admin/ShapefileCreate'
import ShapefileUpdate from '../../components/Admin/ShapefileUpdate'

const useStyles = makeStyles(theme => ({
  fab: {
    background: green[500],
    color: '#FFF'
  },
  title: {
    padding: 5
  }
}))

const estados = {
  'pendiente': <HourglassEmpty style={{color: blue[500]}} />,
  'fallo': <Close style={{color: red[500]}} />,
  'listo': <Check style={{color: green[500]}} />
}

const MantenimientoShapefiles = () => {
  const classes = useStyles()
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [dgCrear, setDgCrear] = useState(false)
  const [dgEditar, setDgEditar] = useState(false)
  const [selected, setSelected] = useState(null)
  const getItems = async () => {
    try {
      setLoading(true)
      const data = await http.get('/maestros/shapefile')
      setItems(data)
    } catch (error) {
      toast.error('Ha ocurrido un error')
    } finally {
      setLoading(false)
    }
  }
  const refresh = () => {
    getItems()
    setDgCrear(false)
    setDgEditar(false)
  }
  const editItem = (cellData) => {
    const { data } = cellData
    setSelected({...data})
    setDgEditar(true)
  }
  const deleteItem = async (cellData) => {
    if (window.confirm('¿Estas seguro de borrar el registro?')) {
      try {
        const { data } = cellData
        await http.delete(`/maestros/shapefile/${data.IdShapefile}`,
          { data: {UsuarioModifico: getIdentity()} })
        getItems()
      } catch (error) {
        toast.error('Ha ocurrido un error')
      }
    }
  }
  useEffect(() => {
    getItems()
  }, [])
  const CellOpciones = (cellData) => (
    <div>
      <IconButton onClick={() => editItem(cellData)} size="small">
        <Edit />
      </IconButton>
      <IconButton onClick={() => deleteItem(cellData)} size="small">
        <Delete />
      </IconButton>
    </div>
  )
  const CellEstado = (cellData) => {
    return <div>{estados[cellData.data.Estado]}</div>
  }
  return <Layout title="Shapefiles">
    <Grid container justify="center">
      <Grid item xs={12} md={10}>
      <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className={classes.title}
        >
          <Typography variant="h5" component="p">Shapefiles</Typography>
          <Fab
            size="small"
            color="inherit"
            className={classes.fab}
            onClick={() => setDgCrear(true)}
          >
            <Add />
          </Fab>
        </Box>
        {
          loading && <LinearProgress />
        }
        <DataGrid id="gridShapefiles"
          dataSource={items}
          showBorders
          showColumnLines
          rowAlternationEnabled
          height='80vh'
        >
          <Column caption="Nombre" dataField="Nombre" />
          <Column caption="Descripción" dataField="Descripcion" />
          <Column caption="Zafra" dataField="Zafra" />
          <Column caption="Estado" cellRender={CellEstado} />
          <Column caption="Opciones" cellRender={CellOpciones} />
        </DataGrid>
      </Grid>
    </Grid>
    <Dialog open={dgCrear} maxWidth="sm" fullWidth>
      <ShapefileCreate
        onClose={() => setDgCrear(false)}
        onRefresh={refresh}
      />
    </Dialog>
    <Dialog open={dgEditar} maxWidth="sm" fullWidth>
      <ShapefileUpdate
        values={selected}
        onClose={() => setDgEditar(false)}
        onRefresh={refresh}
      />
    </Dialog>
  </Layout>
}

export default MantenimientoShapefiles